import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    color: ${({ theme }) => theme.colors.text.primary};
    background-color: ${({ theme }) => theme.colors.background.primary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 400;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    font-family: ${({ theme }) => theme.fonts.primary};
    cursor: pointer;
    border: none;
    background: none;
  }

  input, textarea, select {
    font-family: ${({ theme }) => theme.fonts.primary};
  }
`;

export const MobileGlobalStyle = createGlobalStyle`
  @media (max-width: 767.98px) {
    /* iOS zooms into inputs with a font size below 16px */
    input, textarea, select,
    .ant-select-selector, .ant-select-selection-search-input, .ant-select-selection-item,
    .ant-picker-input > input, .ant-input-number-input {
      font-size: 16px !important;
    }

    /* Confirmation buttons are tiny by default; make them touch sized */
    .ant-popconfirm-buttons .ant-btn,
    .ant-modal-footer .ant-btn,
    .ant-modal-confirm-btns .ant-btn {
      height: 44px;
      padding: 0 16px;
    }

    /* Wide tables scroll inside their card instead of being cut off */
    .ant-table-wrapper .ant-table-content,
    .ant-table-wrapper .ant-table-body {
      overflow-x: auto !important;
    }

    .ant-table-wrapper .ant-table-thead > tr > th {
      white-space: nowrap;
    }

    .ant-segmented {
      max-width: 100%;
      overflow-x: auto;
    }

    .ant-space:not(.ant-space-vertical),
    .ant-card-head-wrapper {
      flex-wrap: wrap;
    }

    .ant-space,
    .ant-space-item {
      max-width: 100%;
    }

    /* Card titles keep their full width and the extra actions wrap below them */
    .ant-card-head-title {
      flex: 1 0 auto !important;
      max-width: 100%;
      white-space: normal;
    }

    .ant-card-extra {
      margin-inline-start: 0;
      padding-bottom: 8px;
    }

    .ant-card-body {
      padding: 12px;
    }

    /* Order detail: touch sized controls like on the product edit page */
    .admin-order .ant-card .ant-btn,
    .admin-order .ant-select {
      min-height: 44px;
    }

    .ant-tabs-nav-operations {
      flex-shrink: 0;
    }
  }
`;
